/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { TableInitBase } from 'utils/hooks/useTable'

export const applyTablePage = (
    tableInit: TableInitBase,
    res: { data: any[]; current_page: number; per_page: number; total: number }
) => {
    if (!tableInit || !res) return
    tableInit.setRecordsTable(res.data || [])
    tableInit.setPagination({
        pageIndex: (res.current_page ?? 1) - 1,
        pageSize: tableInit.pageSize,
    })
    const per = (res.per_page ?? tableInit.pageSize) || 1
    const totalPages = Math.ceil((res.total || 0) / per)
    tableInit.setPaginationTotal(totalPages)
    tableInit.setRecordsCount(res.total || 0)
}

export default applyTablePage
